
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogButtonMobileRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogButtonMobileRT(): TemplateResult<dialogButtonMobileRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('svg', {
                'width': '28',
                'height': '28',
                'viewBox': '0 0 28 28',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('g', { 'id': 'Icons' }, _createElement('mask', {
                'id': 'mask0_1048_6435_11',
                'style': { maskType: 'alpha' },
                'maskUnits': 'userSpaceOnUse',
                'x': '0',
                'y': '0',
                'width': '28',
                'height': '28'
            }, _createElement('rect', {
                'id': 'Bounding box',
                'width': '28',
                'height': '28',
                'fill': '#D9D9D9'
            })), _createElement('g', { 'mask': 'url(#mask0_1048_6435_11)' }, _createElement('path', {
                'id': 'search',
                'd': 'M20.179 21.9795L14.8798 16.6803C14.4842 16.9531 14.0239 17.1714 13.4987 17.335C12.9736 17.4987 12.4041 17.5806 11.7903 17.5806C10.1807 17.5806 8.8133 17.0179 7.68798 15.8926C6.56266 14.7673 6 13.3998 6 11.7903C6 10.1807 6.56266 8.8133 7.68798 7.68798C8.8133 6.56266 10.1807 6 11.7903 6C13.3998 6 14.7673 6.56266 15.8926 7.68798C17.0179 8.8133 17.5806 10.1807 17.5806 11.7903C17.5806 12.4177 17.4987 12.9872 17.335 13.4987C17.1714 14.0102 16.9531 14.4569 16.6803 14.8389L22 20.179L20.179 21.9795ZM11.7903 15.0026C12.6905 15.0026 13.451 14.6922 14.0716 14.0716C14.6922 13.451 15.0026 12.6905 15.0026 11.7903C15.0026 10.89 14.6922 10.1296 14.0716 9.50895C13.451 8.88832 12.6905 8.57801 11.7903 8.57801C10.89 8.57801 10.1296 8.88832 9.50895 9.50895C8.88832 10.1296 8.57801 10.89 8.57801 11.7903C8.57801 12.6905 8.88832 13.451 9.50895 14.0716C10.1296 14.6922 10.89 15.0026 11.7903 15.0026Z',
                'fill': 'url(#paint0_linear_1048_6435_11)'
            }))), _createElement('defs', {}, _createElement('linearGradient', {
                'id': 'paint0_linear_1048_6435_11',
                'x1': '14',
                'y1': '6',
                'x2': '14',
                'y2': '21.9795',
                'gradientUnits': 'userSpaceOnUse'
            }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
                'offset': '1',
                'stopColor': '#27AAE1'
            })))));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]